import React from "react";
import "./_club-contact-details.scss";
import PhoneIcon from "../../assets/icons/phone.svg"
import MailIcon from "../../assets/icons/mail.svg";
import WebIcon from "../../assets/icons/web.svg";
import PhoneIconBlue from "../../assets/icons/phone-Icon-blue.svg"
import MailIconBlue from "../../assets/icons/mail-icon-blue.svg";
import WebIconBlue from "../../assets/icons/web-icon-blue.svg";
import {AppVersionForTenants} from "../../../constants/Config";

interface ClubContactDetailsPropType {
  contactNumber: string
  mailId: string
  websiteText: string
  tenant?: string
}

const ClubContactDetails = (props: ClubContactDetailsPropType): JSX.Element => {
  let phoneIcon,
    webIcon,
    mailIcon;

  if (props.tenant == 'nzc') {
    phoneIcon = PhoneIcon
    webIcon = WebIcon
    mailIcon = MailIcon
  } else if (props.tenant && AppVersionForTenants.v2.tenants.includes(props.tenant)) {
    phoneIcon = PhoneIconBlue
    webIcon = WebIconBlue
    mailIcon = MailIconBlue
  }

  return (
    <div className={'clubContactDetailsContainer'}>
      {(props.contactNumber || props.mailId || props.websiteText) && (
        <div className={'heading'}>
          Contact Details
        </div>
      )}
      {props.contactNumber && (
        <div className={'clubDetailRow'}>
          <img src={phoneIcon} className={'icon'} alt="logo"/>
          <a className={'clubContactDetailText'} href={`tel:${props.contactNumber}`}>{props.contactNumber}</a>
        </div>
      )}
      {props.mailId && (
        <div className={'clubDetailRow'}>
          <img src={mailIcon} className={'icon'} alt="logo"/>
          <a className={'clubContactDetailText'} href={`mailto:${props.mailId}`}>{props.mailId}</a>
        </div>
      )}
      {props.websiteText && (
        <div className={'clubDetailRow'}>
          <img src={webIcon} className={'icon'} alt="logo"/>
          <a className={'clubContactDetailText'} href={props.websiteText}  target='_blank'>{props.websiteText}</a>
        </div>
      )}
    </div>
  )
}

export default ClubContactDetails;
